import { apiPost } from './client';
import type {
  LinkAwsMarketplaceRequest,
  LinkAwsMarketplaceResponse,
} from '@/types/marketplace';

/**
 * Link a pending AWS Marketplace contract to the authenticated caller's org.
 *
 * Exchanges the opaque `ref` link token (from the AWS redirect) for an
 * entitlement. The backend sets `org.plan` authoritatively and returns the
 * activated plan. Requires JWT auth (the default for `apiPost`).
 *
 * @throws {ApiRequestError} with `.status` 404 (registration not found / bad or
 *   expired ref), 409 (already linked to another org), 422 (no active
 *   entitlement), or 502 (could not read the entitlement from AWS).
 */
export async function linkAwsMarketplace(
  ref: string,
): Promise<LinkAwsMarketplaceResponse> {
  const body: LinkAwsMarketplaceRequest = { ref };
  return apiPost<LinkAwsMarketplaceResponse>('/marketplace/aws/link', body);
}
